// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"245":"b651bc7a","249":"d772ca88","301":"7f15ae06","611":"c7473900","753":"ef757323","816":"7bffa9f1","819":"dfff8973","849":"ad52a309","878":"62427742"}[chunkId] + ".js";
};